import weeklyrecommend01 from "@/assets/image/weeklyrecommend01.webp";
import weeklyrecommend02 from "@/assets/image/weeklyrecommend02.webp";
import weeklyrecommend03 from "@/assets/image/weeklyrecommend03.webp";

const weeklyRecommendData = [
  {
    image: weeklyrecommend01,
    alt: "백팩 GH 이태원",
    location: "서울",
    type: "패밀리/단체형",
    name: "백팩 GH 이태원",
  },
  {
    image: weeklyrecommend02,
    alt: "인천공항 라인 게스트하우스",
    location: "인천",
    type: "프라이빗형",
    name: "인천공항 라인 게스트하우스",
  },
  {
    image: weeklyrecommend03,
    alt: "오게스트",
    location: "부산",
    type: "테마/특수형",
    name: "오게스트",
  },
  // 임시 데이터 3개 추가
  {
    image: weeklyrecommend01,
    alt: "백팩 GH 이태원",
    location: "서울",
    type: "패밀리/단체형",
    name: "백팩 GH 이태원",
  },
  {
    image: weeklyrecommend02,
    alt: "인천공항 라인 게스트하우스",
    location: "인천",
    type: "프라이빗형",
    name: "인천공항 라인 게스트하우스",
  },
  {
    image: weeklyrecommend03,
    alt: "오게스트",
    location: "부산",
    type: "테마/특수형",
    name: "오게스트",
  },
];

export default weeklyRecommendData;
